import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '../../node_modules/@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {
    url = environment.apiUrl;
    baseUrl = environment.apiBaseUrl;
    /* url = 'http://localhost:5596/api/'; */
    // url = 'https://dev.garciatech.co:444/api/';
    //  url = 'http://buybackapierror.garciatech.co/api/';
    headers: HttpHeaders;
    tokenBody = {
        // "userName": "",
        // "password": "",
        // "ip": ""
    };
    constructor() {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.headers.append('Accept', 'application/json');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts